import * as React from 'react';
import { PromoBlock } from '../../components/PromoBlock';
import { INewBuildingPromo } from '../../types/newBuldings/promo';

interface IPromoBlockProps {
  promos?: INewBuildingPromo[] | null;
  url: string;
}

export function PromoBlockContainer({ promos, url }: IPromoBlockProps) {
  const promoUrl = `${url}#promoList`;

  if (!promos || !promos.length) {
    return null;
  }

  return <PromoBlock promos={promos} url={promoUrl} />;
}
